import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'ds-optional-discounts-list',
  templateUrl: './optional-discounts-list.component.html',
  styleUrls: ['./optional-discounts-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DiscountsListComponent implements OnInit {
  @Input() form: UntypedFormGroup;

  goPaperlessCtrl: AbstractControl;

  ngOnInit() {
    this.form.addControl('goPaperlessChecked', new UntypedFormControl(''));
    this.goPaperlessCtrl = this.form.controls['goPaperlessChecked'];
  }

  toggleCtrl() {
    this.goPaperlessCtrl.setValue(!this.goPaperlessCtrl.value);
  }
}
